"use client";

import React, { useState, useEffect } from "react";
import { SmilePlus } from "lucide-react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { Button } from "@/components/catalyst/button";
import { updateReaction } from "@/lib/actions/blog";
import { toast } from "sonner";

const BlogPostReactions = ({
  id,
  slug,
  onEmojiSelect,
}: {
  id: string;
  slug: string;
  onEmojiSelect?: (emoji: any) => void;
}) => {
  // Initialize state with null to avoid hydration errors
  const [showPicker, setShowPicker] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Set mounted flag after hydration
  useEffect(() => {
    setMounted(true);
  }, []);

  const handleEmojiSelect = async (emoji) => {
    try {
      // Hide the picker immediately for better UX
      setShowPicker(false);

      // If custom handler provided, use it
      if (onEmojiSelect) {
        onEmojiSelect(emoji);
        return; // Exit early as the parent will handle the UI update
      }

      // Get a descriptive title for the emoji
      const emojiTitle =
        emoji.native === "👍"
          ? "Thumbs Up"
          : emoji.native === "👌"
            ? "Ok Hand"
            : emoji.name;

      // Use post ID instead of slug for reaction
      await updateReaction(id, emoji.native, emojiTitle);

      toast.success(`You reacted with ${emoji.native}`);
    } catch (error) {
      toast.error("Could not add your reaction");
      console.error("Error updating reaction:", error);
    }
  };

  const handleEmojiPickerClick = () => {
    setShowPicker(!showPicker);
  };

  // Avoid rendering picker if not mounted to prevent hydration issues
  if (!mounted) {
    return (
      <div className="flex items-center justify-center">
        <Button plain className="relative px-2 py-2">
          <SmilePlus />
        </Button>
      </div>
    );
  }

  return (
    <div className="ml-2 flex items-center justify-center">
      <div className="relative">
        <Button
          plain
          onClick={handleEmojiPickerClick}
          className="relative px-2 py-2"
        >
          <SmilePlus />
        </Button>
        {showPicker && (
          <div className="absolute right-0 top-12 z-50">
            <Picker
              type="submit"
              data={data}
              previewPosition="none"
              skinTonePosition="none"
              onEmojiSelect={handleEmojiSelect}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPostReactions;
